import http from '@services/http'
import { ICheerForTeamCreate, ICheerForTeamDelete, ISportTalkList } from '@protocol/cheer-for-team'

class CheerForTeam {
  async fetchSportTalkList(params: ISportTalkList.Params): Promise<ISportTalkList.Schema> {
    return http.get('cheerForTeam/list', params || {})
  }

  async createCheerForTeam(params: ICheerForTeamCreate.Params): Promise<ICheerForTeamCreate.Schema> {
    return http.post('cheerForTeam/create', params || {})
  }

  async deleteCheerForTeam(params: ICheerForTeamDelete.Params): Promise<ICheerForTeamDelete.Schema> {
    return http.post('cheerForTeam/delete', params || {})
  }
}

export default new CheerForTeam()
